import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10h16","key":"svg-0"}],["path",{"d":"M6.5 4.5l11 11","key":"svg-1"}],["path",{"d":"M6.5 15.5l11 -11","key":"svg-2"}],["path",{"d":"M12 10v-8","key":"svg-3"}],["path",{"d":"M12 15v7","key":"svg-4"}]]

const IconBrandLinktree = createReactComponent('outline', 'brand-linktree', 'BrandLinktree', __iconNode);

export default IconBrandLinktree;